<template>
  <div class="choose-seal-mobile">
    <van-nav-bar title="添加印章" left-arrow @click-left="goBack"/>
    <!--tab选择 -->
    <van-tabs v-model="active">
      <van-tab v-for="(item,index) in tabItems" :key="index" :disabled="index !== 0" :title="item.label" :name="item.value">
        <!--具体签章列表数据 -->
        <template v-if="personalSealList.length>0">
          <div v-for="(item, idx) in sliceSealList" :key="idx" class="seal-row">
            <div v-show="active === 0 && child.downloadUrl" v-for="(child, i) in sliceSealList[idx]" :key="i" class="seal-item"   
                :class="child.isChoosed ? 'isChecked' : ''">
              <img :src="child.downloadUrl" @click="choosePersonSeal(child)" alt="" class="seal-item-img" />
            </div>
          </div>
        </template>
        <template v-else>
          <van-empty description="暂无数据" /> 
          <van-loading  v-if="loading" class="seal-list-loading" vertical color="#1989fa" type="spinner">加载中...</van-loading>
        </template>     
      </van-tab>
    </van-tabs>
    <!--确定按钮 -->
    <van-button  type="info" block @click="confirm">确 定</van-button>
  </div>
</template>
<script>
  import { getSealListFromApi, serializeSealListData } from './utils/get-data'
  import messageApi from '@/utils/messagebox'
export default {
  name:'SealListM',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    sealConfigData: {
      type: [Object, null],
      default: null
    }
  },
  data(){
    return {
      loading:false,//初始化加载
      active:0,
      personalSealList: [],
      sliceSealList:[],//拆解数据
      choosedSeal:{},//选中的个人签章
      tabItems:[
        {
          value:0,
          label:'个人印章'
        },{
          value:1,
          label:''
        },{
          value:2,
          label:''
        }
      ]
    }
  },
  mounted(){
    this.initData();
  },
  methods:{
    goBack(){
      this.$emit('on-go-back')
    },

    // 初始化列表
    initData(){
       this.active = 0
      if(this.active === 0){
        this.personalSealList = []
        this.sliceSealList = []
        this.choosedSeal = {}
        this.reFindPersonalSealList()
      }
    },
  
     //获取个人签章列表数据
    reFindPersonalSealList() {
      if(this.loading) return
      this.loading = true;
      if (!this.sealConfigData) messageApi("getSealConfig.do接口未初始化!", 'error')
      const getSealConfig = this.sealConfigData.datas.getSealConfig
      const host = getSealConfig.signatureHostUrl
      const data = {
        appID: getSealConfig.signatureAppId,
        appSecret: getSealConfig.signatureSecret,
        id: getSealConfig.signatureUser
      }
      return getSealListFromApi(host, data).then((res) => {
        this.loading = false;
        serializeSealListData(res).forEach(item => {
          this.personalSealList.push(item)
        })
  
        for(var i=0;i< this.personalSealList.length; i+=2 ){
          this.sliceSealList.push(this.personalSealList.slice(i,i+2));
        }
      }).catch(e => {
        this.loading = false;
        console.log(e,'111');
        console.error(e)
      })
    },

    /**
     * 选择个人签章
     */
    choosePersonSeal(item){
      for (var i= 0;  i < this.sliceSealList.length; i++) {
        let seal = this.sliceSealList[i]
        for( var j=0; j<seal.length; j++){
          seal[j].isChoosed = false
          if(seal[j].signid === item.signid){
            seal[j].isChoosed = true
          }
        }
      }
      this.choosedSeal = JSON.parse(JSON.stringify(item))
      this.choosedSeal.url = this.choosedSeal.downloadUrl
    },

    confirm(){
      //this.btnLoading = true
      let len = Object.keys(this.choosedSeal).length
      if(!len){
        this.$toast.fail("请选择电子签章");
      }else {
        this.$emit("choose-seal", this.choosedSeal)
      }
    }

  }
}
</script>
<style lang="css">
.choose-seal-mobile {
  height: 100%;
}
 .choose-seal-mobile .van-nav-bar .van-icon {
   color: #323233 
 }
 .choose-seal-mobile .van-tabs__line {
   width: 55px;
   background-color: #2196F3;
 }
 .choose-seal-mobile .van-tabs {
    height: calc(100% - 96px);
 }
 .choose-seal-mobile .van-tabs__content {
    height: calc(100% - 44px);
    padding: 10px 17px;
 }
 .choose-seal-mobile .van-tab__pane {
   height: 100%;
 }
 .seal-list-loading {
   display: flex;
    align-items: center;
    justify-content: center;
    height: calc(100% - 44px);
    position: absolute;
    top: 44px;
    padding: 10px 0;
    width: calc(100% - 34px);
    background-color: rgba(255,255,255,0.7);
 }
 .choose-seal-mobile .van-empty {
   display: flex;
   align-items: center;
   flex-direction: column;
   height: 100%;
   justify-content: center;
 }
 .choose-seal-mobile .van-empty__image {
   width: 160px;
   height: 160px;
 }
 .choose-seal-mobile .van-empty__image img {
   width:100%;
   height: 100%;
 }
 .choose-seal-mobile .van-empty__description {
    margin-top: 16px;
    padding: 0 60px;
    color: #969799;
    font-size: 14px;
    line-height: 20px;
 }
.choose-seal-mobile .seal-row {
  display: flex;
  justify-content: space-around;  
  padding-bottom: 10px;
}
 .choose-seal-mobile .seal-item {
    width: 130px;
    height: 130px;
 }
 .choose-seal-mobile .seal-item .seal-item-img {
    width: 100%;
    height: 100%;
 }
  .choose-seal-mobile .seal-item.isChecked {
    border: 1px solid #307bf6;
  }
</style>